import { detectAds } from './ads.js';
import { socialShares } from './social.js';
import { emailForms } from './email.js';
import { navDrawer } from './nav.js';

document.addEventListener('DOMContentLoaded', (event) => {
	detectAds();
	socialShares();
	emailForms();
	navDrawer();
});

// https://philipwalton.com/articles/loading-polyfills-only-when-needed/
function isModernBrowser() {
	return window.Promise && window.fetch && window.Symbol;
}
if (!isModernBrowser()) {
	const header = document.querySelector('header');
	header.insertAdjacentHTML(
		'afterend',
		'<div class="alert">Your browser is no longer supported – please <a href="https://updatemybrowser.org/">upgrade for the best experience</a>.</div>'
	);
}
